<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-form>
      <v-card-text>
        <v-card-title>
          <v-icon
            size="26"
            class="text--primary me-3"
          >
            {{ icons.mdiFolderInformationOutline }}
          </v-icon>
          <span>Dados</span>
        </v-card-title>

        <v-row class="mt-3">
          <v-col
            md="4"
            sm="4"
            cols="12"
          >
            <v-text-field
              v-model="accountDataLocale.usuario"
              label="Empresa"
              disabled
              outlined
              dense
              hide-details
              placeholder="Empresa"
            >
            </v-text-field>
          </v-col>

          <v-col
            md="4"
            sm="8"
            cols="12"
          >
            <v-select
              v-model="accountDataLocale.idDepartamento"
              label="Departamento"
              :rules="[validators.select]"
              :items="departamentos"
              item-text="nome"
              item-value="id"
              outlined
              dense
              hide-details
              placeholder="Departamento"
            >
            </v-select>
          </v-col>

          <v-col
            md="4"
            sm="4"
            cols="12"
          >
            <v-select
              v-model="accountDataLocale.idCargo"
              label="Cargo"
              :rules="[validators.select]"
              :items="cargos"
              item-text="nome"
              item-value="id"
              outlined
              dense
              hide-details
              placeholder="Cargo"
            >
            </v-select>
          </v-col>

          <v-col cols="12">
            <v-card-title>
              <v-icon
                size="26"
                class="text--primary me-3"
              >
                {{ icons.mdiCellphone }}
              </v-icon>
              <span>Telefones</span>
            </v-card-title>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-select
              v-model="tipo"
              dense
              outlined
              label="Tipo"
              :items="tiposDeNumero"
              :rules="[validators.select]"
            ></v-select>
          </v-col>

          <v-col
            cols="12"
            md="3"
          >
            <v-text-field
              v-if="tipo === 'Fixo'"
              v-model="numero"
              v-mask="'(##) ####-####'"
              outlined
              dense
              label="Fixo"
              :rules="[validators.isTelefoneFixoValido]"
            ></v-text-field>

            <v-text-field
              v-else
              v-model="numero"
              v-mask="'(##) #####-####'"
              outlined
              dense
              label="Celular"
              :rules="[validators.isTelefoneCelularValido]"
            ></v-text-field>
          </v-col>

          <v-col
            v-if="tipo === 'Fixo'"
            cols="12"
            md="2"
          >
            <v-text-field
              v-model="ramal"
              outlined
              dense
              label="Ramal"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            md="2"
          >
            <v-card-text>
              <v-btn
                color="primary"
                @click="save"
              >
                Criar
              </v-btn>
            </v-card-text>
          </v-col>

          <v-col cols="12">
            <table-telefone v-model="accountDataLocale.telefones"></table-telefone>
          </v-col>
        </v-row>
      </v-card-text>

      <v-col cols="12">
        <v-btn
          v-if="acessoPut"
          color="primary"
          class="me-3 mt-4"
          @click="update"
        >
          <v-progress-circular
            v-if="loading"
            class="mx-6"
            indeterminate
            color="secundary"
          ></v-progress-circular>
          <span v-else>Salvar alterações</span>
        </v-btn>
        <v-btn
          v-else
          color="primary"
          class="me-3 mt-4"
          disabled
        >
          Salvar alterações
        </v-btn>
        <v-btn
          color="secondary"
          outlined
          class="mt-4"
          type="reset"
          @click.prevent="resetForm"
        >
          Cancelar
        </v-btn>
      </v-col>
    </v-form>
  </v-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiFolderInformationOutline, mdiCellphone } from '@mdi/js'
import { alphaValidator, emailValidator, passwordValidator, required, select } from '@core/utils/validation'
import { cepRequired, isTelefoneCelularValido, isTelefoneFixoValido } from '@/utils/validation'
import TableTelefone from '@/components/tables/TableTelefone.vue'
import ColaboradorService from '@/services/modules/ColaboradorService'
import DepartamentoService from '@/services/modules/DepartamentoService'
import CargoService from '@/services/modules/CargoService'

export default {
  components: {
    TableTelefone,
  },

  props: {
    infoData: {
      type: Object,
      default: () => {},
    },
    acessoPut: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: false,
      numero: '',
      tipo: '',
      ramal: '',
      tipoContato: '',
      data: [],
      erro: false,
      departamentos: [],
      cargos: [],
    }
  },

  beforeMount() {
    this.getDepartamento()
    this.getCargo()
    if (!this.accountDataLocale.telefones) {
      this.accountDataLocale.telefones = []
    }
  },

  methods: {
    save() {
      if (!this.numero || !this.tipo) {
        this.$toast.error('Preencha o número e o tipo de telefone')
      } else if (this.accountDataLocale.telefones.some(tel => tel.numero === this.numero.trim())) {
        this.$toast.error('Número já cadastrado')
      } else {
        this.accountDataLocale.telefones.push({
          numero: this.numero,
          ramal: this.ramal,
          tipo: this.tipo,
          tipoContato: this.tipoContato,
        })
        this.tipo = ''
        this.numero = ''
        this.ramal = ''
        this.tipoContato = ''
      }
    },

    update() {
      this.loading = true
      this.accountDataLocale.senha = null
      this.accountDataLocale.id = null

      ColaboradorService.update(this.accountDataLocale)
        .finally(() => {
          this.loading = false
        })
    },

    async getDepartamento() {
      this.departamentos = await DepartamentoService.get()
    },

    async getCargo() {
      this.cargos = await CargoService.get()
    },
  },
  setup(props) {
    const estados = [
      'AC',
      'AL',
      'AP',
      'AM',
      'BA',
      'CE',
      'DF',
      'ES',
      'GO',
      'MA',
      'MT',
      'MS',
      'MG',
      'PA',
      'PB',
      'PR',
      'PE',
      'PI',
      'RJ',
      'RN',
      'RS',
      'RO',
      'RR',
      'SC',
      'SP',
      'SE',
      'TO',
    ]
    const tiposDeNumero = ['CELULAR', 'FIXO']
    const accountDataLocale = ref(JSON.parse(JSON.stringify(props.infoData)))

    const resetForm = () => {
      accountDataLocale.value = JSON.parse(JSON.stringify(props.infoData))
    }

    return {
      estados,
      tiposDeNumero,
      accountDataLocale,
      resetForm,
      validators: {
        cepRequired,
        required,
        emailValidator,
        passwordValidator,
        alphaValidator,
        select,
        isTelefoneCelularValido,
        isTelefoneFixoValido,
      },
      icons: {
        mdiFolderInformationOutline,
        mdiCellphone,
      },
    }
  },
}
</script>
